/** Coerce an API payload to an array so `.length` / `.map` never crash. */
export function asArray<T = any>(value: unknown): T[] {
  return Array.isArray(value) ? value : [];
}
